import styled from 'styled-components';

export const $DrawerHeader = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
  padding-right: 2.5rem;
`;

export const $CloseButtonWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const $StepTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem;
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
`;

export const $StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const $ActionOption = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  font-size: 0.9375rem;
  background: ${({ theme }) =>
    theme.newUI?.variationColors?.light5 ?? theme.colors?.lightGrey ?? '#f5f5f5'};
  border: 1px solid
    ${({ theme }) =>
      theme.newUI?.variationColors?.light3 ?? theme.colors?.default ?? '#e0e0e0'};
  border-radius: ${({ theme }) =>
    theme.newUI?.borders?.mediumRadius ?? theme.borders?.radius ?? '6px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: ${({ theme }) =>
      theme.newUI?.variationColors?.light4 ?? '#ebebeb'};
    border-color: ${({ theme }) =>
      theme.colors?.primary ?? '#5369eb'};
  }
`;

export const $ActionOptionLocked = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  font-size: 0.9375rem;
  background: ${({ theme }) =>
    theme.newUI?.variationColors?.light5 ?? theme.colors?.lightGrey ?? '#f5f5f5'};
  border: 1px solid
    ${({ theme }) =>
      theme.newUI?.variationColors?.light3 ?? theme.colors?.default ?? '#e0e0e0'};
  border-radius: ${({ theme }) =>
    theme.newUI?.borders?.mediumRadius ?? theme.borders?.radius ?? '6px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#888'};
  cursor: not-allowed;
  opacity: 0.85;
`;

export const $LockIconWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const $ConfirmButtonWrap = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
`;

export const $SelectedActionStrip = styled.div`
  padding: 10px 14px;
  margin-bottom: 1rem;
  font-size: 0.9375rem;
  background: ${({ theme }) =>
    theme.newUI?.variationColors?.light5 ?? theme.colors?.lightGrey ?? '#f5f5f5'};
  border-left: 3px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  border-radius: ${({ theme }) =>
    theme.newUI?.borders?.smallRadius ?? '4px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
`;

export const $SelectedActionLabel = styled.span`
  font-weight: 600;
  margin-right: 0.35rem;
`;

export const $BackButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
`;

export const $BackButton = styled.button`
  padding: 0;
  font-size: 0.875rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const $UserSelectLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
`;

export const $UserSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  font-size: 0.9375rem;
  border: 1px solid
    ${({ theme }) =>
      theme.newUI?.variationColors?.light3 ?? theme.colors?.default ?? '#e0e0e0'};
  border-radius: ${({ theme }) =>
    theme.newUI?.borders?.smallRadius ?? '4px'};
  background: ${({ theme }) =>
    theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  }
`;
